import { forwardRef } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";

import {
  SHEET_TITLE_DEFAULTS,
  SHEET_TYPOGRAPHY_ALIGN_PROPS,
  type TSheetTitleElement,
  type TSheetTitleProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "../../typography/TextSubtitle";

export const SheetTitle = forwardRef<TSheetTitleElement, TSheetTitleProps>(
  (
    {
      className,
      children,
      align = SHEET_TITLE_DEFAULTS.align,
      ...props
    },
    ref,
  ) => (
    <SheetPrimitive.Title
      data-component="SheetTitle"
      ref={ref}
      className={cn(
        "font-sys-heading text-sys-lg leading-sys-1-2 text-foreground",
        className,
      )}
      {...props}
    >
      <TextSubtitle
        tag="span"
        size={3}
        isResponsive={false}
        align={SHEET_TYPOGRAPHY_ALIGN_PROPS[align]}
        className="block"
      >
        { children }
      </TextSubtitle>
    </SheetPrimitive.Title>
  ),
);

SheetTitle.displayName = SheetPrimitive.Title.displayName;
